import React from 'react';
import PropTypes from 'prop-types';

import { FormModal, Copy07Icon } from '@metarouter-private/mr-mui';

import CloneIntegrationForm from './CloneIntegrationForm';
import useCloneIntegrationModal from './useCloneIntegrationModal';

const MODAL_CONFIG = {
  title: 'Clone Integration',
  helperText:
    'Create a copy of this integration with all its event mappings and settings. You can edit the cloned integration to update credentials like API keys. Once cloned, each integration must be managed and updated separately.',
  TitleIcon: Copy07Icon,
  submitLabel: 'Clone Integration',
};

export default function CloneIntegrationModal({ open, integration, onClose }) {
  const { defaultName, pipelines, existingNames, onSubmit, loading } = useCloneIntegrationModal({
    integration,
    onClose,
  });

  return (
    <FormModal open={open} onClose={onClose} onSubmit={onSubmit} loading={loading} {...MODAL_CONFIG}>
      <CloneIntegrationForm defaultName={defaultName} existingNames={existingNames} pipelines={pipelines} />
    </FormModal>
  );
}

CloneIntegrationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  integration: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    starterkitId: PropTypes.string,
    starterkitVersion: PropTypes.string,
    playbooks: PropTypes.array,
    integration_notes: PropTypes.shape({
      notes: PropTypes.string,
    }),
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};
